import React, { useState } from 'react';
import { DimensionValue, StyleSheet } from 'react-native';

import BumoCarousel from './BumoCarousel';
import Dots from './Dots';
import { TransparentRow } from './Row';
import GiftCardDetail from './gift_card/GiftCardDetail';
import { useMaxWidth } from '../hooks/useResponsive';

const details = [
  'Date Night',
  '"Me" Time',
  "Mom's Night Out",
  'Running Errands',
];

const DefaultWrapper = ({ children }: { children: React.ReactNode }) => {
  const isMobileDevice = useMaxWidth(500);

  return (
    <TransparentRow
      style={[
        styles.spaceBetween,
        styles.detailsRow,
        isMobileDevice && styles.detailsRowMobile,
      ]}
    >
      {children}
    </TransparentRow>
  );
};

export default function GiftCardVoucherDetails({
  Wrapper = DefaultWrapper,
}: {
  Wrapper?: ({ children }: { children: React.ReactNode }) => React.ReactNode;
}) {
  const isMobileDevice = useMaxWidth(500);
  const isSmallDevice = useMaxWidth(800);

  return (
    <Wrapper>
      {details.map((text, index) => (
        <GiftCardDetail
          title={text}
          key={index}
          imageIndex={index + 1}
          accent={index % 2 === 0}
          style={[
            styles.detail,
            isSmallDevice && styles.detailWide,
            isMobileDevice && styles.detailFullWidth,
          ]}
        />
      ))}
    </Wrapper>
  );
}

const styles = StyleSheet.create({
  spaceBetween: {
    justifyContent: 'space-between',
  },

  detailsRow: {
    marginTop: 55,
    gap: 10,
    flexWrap: 'wrap',
  },
  detailsRowMobile: {
    marginTop: 50,
    flexDirection: 'column',
    gap: 20,
  },

  detailWide: {
    width: 'calc((100% - 20px) / 2)' as DimensionValue,
  },
  detailFullWidth: {
    width: '100%',
  },
  detail: {
    width: 'calc((100% - 5 * 10px) / 4)' as DimensionValue,
    height: 290,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
